export default {"src":"/_next/static/media/No_Image_State.18a4f5fe.svg","height":177,"width":168,"blurWidth":0,"blurHeight":0};